import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Terms() {
  return <div className="pt-0 bg-warmwhite min-h-screen" data-id="element-1329" data-mp="3tq2971sa7pny">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-navy overflow-hidden" data-id="element-1330" data-mp="2i7px9i223s7">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-1331" data-mp="79fxs13qlh39" />
        <div className="container relative z-10 mx-auto px-6 md:px-12 text-center" data-id="element-1332" data-mp="c9an407v5ym7">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1333" data-mp="g9uk93sft28c">
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-1334" data-mp="l74gp3e8ue5o">
              Terms & Conditions
            </h1>
            <p className="text-lg text-white/80 max-w-2xl mx-auto" data-id="element-1335" data-mp="2n13rlnngethu">
              Please read these terms carefully before using the Poch Global platform.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 lg:py-16" data-id="element-1336" data-mp="23axm1gpz7in4">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl" data-id="element-1337" data-mp="1yiwg0cjeio5j">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-softgray prose prose-lg prose-slate max-w-none" data-id="element-1338" data-mp="1ygjob7nuczfa">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1339" data-mp="1pi82rk1u0rtp">1. Acceptance of Terms</h2>
            <p className="text-mediumgray mb-8" data-id="element-1340" data-mp="2m88kx07p4a21">
              By accessing and using the Poch Global website, you accept and agree to be bound by the terms and provision of this agreement.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1341" data-mp="2d7afcdhlzuhc">2. Usage Policies</h2>
            <p className="text-mediumgray mb-8" data-id="element-1342" data-mp="2d9dhfvw1de2f">
              You agree to use our platform for lawful purposes only and in a way that does not infringe the rights of, restrict or inhibit anyone else's use and enjoyment of the website.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1343" data-mp="wshlj24wl9td">3. Donations & Payments</h2>
            <p className="text-mediumgray mb-8" data-id="element-1344" data-mp="ybhkbs470sej">
              All donations made through our platform are final. We use secure third-party payment processors to handle transactions safely.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1345" data-mp="p8zwxacsxtpy">4. Intellectual Property</h2>
            <p className="text-mediumgray mb-8" data-id="element-1346" data-mp="tabqts2pl13y">
              All content included on this site, such as text, graphics, logos, images, and software, is the property of Poch Global or its content suppliers.
            </p>

            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1347" data-mp="kc9l4z815kac">5. Governing Law</h2>
            <p className="text-mediumgray mb-8" data-id="element-1348" data-mp="5n3kd6tjnm0c">
              These terms and conditions are governed by and construed in accordance with the laws, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
            </p>

            <div className="mt-12 pt-8 border-t border-softgray" data-id="element-1349" data-mp="1k76ftey8e2q">
              <p className="text-sm text-mediumgray" data-id="element-1350" data-mp="1jdxclsipchf">
                Last updated: July 2026. For any questions regarding these terms, please <Link to="/contact" className="text-gold hover:underline" data-id="element-1351" data-mp="394ooo492jnjm">contact us</Link>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}